export default __webpack_public_path__ + "static/media/profileSmall.c08f21bb.svg";